import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export const PageCard = ({
  path,
  title,
  description,
  image,
}: {
  path: string;
  title: string;
  description: string;
  image: string;
}) => {
  const navigate = useNavigate();
  return (
    <Card
      className="galactic-card"
      sx={{
        width: 280,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        clipPath: "polygon(0 0, 90% 0, 100% 10%, 100% 100%, 10% 100%, 0 90%)",
        background: "rgba(0, 242, 255, 0.03)",
        border: "1px solid rgba(0, 242, 255, 0.2)",
        position: "relative",
        "&:hover": {
          "& .MuiCardMedia-root": {
            transform: "scale(1.1)",
            filter: "brightness(1.2) contrast(1.1)",
          },
          "& .scanline": {
            display: "block",
          },
        },
      }}
    >
      <CardActionArea
        onClick={() => navigate(path)}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: 160,
            overflow: "hidden",
            position: "relative",
          }}
        >
          <CardMedia
            component="img"
            height="160"
            image={image}
            alt={title}
            sx={{ transition: "all 0.6s ease" }}
          />
          <Box
            className="scanline"
            sx={{
              display: "none",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "4px",
              background: "rgba(0, 242, 255, 0.5)",
              boxShadow: "0 0 10px #00f2ff",
              zIndex: 2,
              animation: "scan 2s linear infinite",
            }}
          />
        </Box>
        <CardContent sx={{ flexGrow: 1, width: "100%" }}>
          <Typography
            gutterBottom
            variant="h6"
            component="div"
            sx={{
              color: "#00f2ff",
              fontFamily: "'Orbitron', sans-serif",
              fontSize: "1rem",
              fontWeight: 700,
              mb: 1,
            }}
          >
            {title.toUpperCase()}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "rgba(224, 250, 255, 0.6)",
              fontSize: "0.8rem",
              lineHeight: 1.5,
            }}
          >
            {description}
          </Typography>
        </CardContent>
        {/* Decorative corner element */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 20,
            height: 20,
            background: "#00f2ff",
            clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
            opacity: 0.5,
          }}
        />
      </CardActionArea>
      <style>{`
        @keyframes scan {
          0% { top: 0; }
          100% { top: 100%; }
        }
      `}</style>
    </Card>
  );
};
